<template>
	<div id="fullScreen" class="view">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>指挥中心</el-breadcrumb-item>
			<el-breadcrumb-item>生产状况监控</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-row>
				<el-col :span="24" style="text-align:right;">
					<el-form :inline="true">
						<el-form-item>
							<el-button type="info" icon="el-icon-back" @click="$router.back()" circle></el-button>
						</el-form-item>
						<el-form-item>
							<el-button icon="el-icon-full-screen" circle @click="handleFullScreen"></el-button>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</div>
		<el-row class="stat-table" v-loading="loading">
			<el-col :span="12">
				<ul>
					<li>
						<label for>工单：</label>
						<span>{{ data.code }}</span>
					</li>
					<li>
						<label for>调机米数：</label>
						<span>{{ data.adjustLength | filterShow }}</span>
					</li>
					<li>
						<label for>良品率：</label>
						<span>{{ (data.yieldRate * 100).toFixed(2) + '%' }}</span>
					</li>
					<li>
						<label for>机器状态：</label>
						<span>{{ data.jt_status_str }}</span>
					</li>
				</ul>
				<div>
					<span v-text="loadingText"></span>
					<ve-pie :data="chartData" style="width:400px;" legend-position="bottom"></ve-pie>
				</div>
			</el-col>
			<el-col :span="12">
				<ul>
					<li>
						<label for>开始时间：</label>
						<span>{{ data.start_time_str }}</span>
					</li>
					<li>
						<label for>结束时间：</label>
						<span>{{ data.end_time_str }}</span>
					</li>
					<li>
						<label for>当前工序：</label>
						<span>{{ data.current_process }}</span>
					</li>
					<li>
						<label for>未处理严重废：</label>
						<span>{{ data.unprocess_serious_defect_count }}</span>
					</li>
					<li>
						<label for>下一工序：</label>
						<span>{{ data.next_process }}</span>
					</li>
					<li>
						<label for>工单状态：</label>
						<span>{{ data.status | WorderStatus }}</span>
					</li>
					<li>
						<label for>印刷机台：</label>
						<span>{{ data.jtInfo.name }}</span>
					</li>
					<li>
						<label for>复合机台：</label>
						<span>暂无</span>
					</li>
					<li>
						<label for>品检机台：</label>
						<span>暂无</span>
					</li>
					<li>
						<label for>分切机台：</label>
						<span>暂无</span>
					</li>
				</ul>
			</el-col>
		</el-row>

		<el-row>
			<el-col :span="4" align="left"></el-col>
			<el-col :span="18" align="right"></el-col>
		</el-row>
	</div>
</template>

<script>
	import jobOrderService from '@/service/jobOrderService'
	import { getDefectOfDefectStatis } from '@/service/reportService'
	import VePie from 'v-charts/lib/pie.common'
	export default {
		components: {
			VePie,
		},
		data() {
			return {
				params: {},
				data: {
					jtInfo: {
						name: '',
					},
				},
				fullscreen: false,
				loading: false,
				chartData: {},
				columns: [],
				loadingText: '',
			}
		},
		computed: {
			job_order_id() {
				if (this.params) {
					return this.params.job_order_id
				}

				return ''
			},
		},
		filters: {
			filterShow(val) {
				if (val) {
					return val / 1000 + '米'
				}
			},
			WorderStatus(val) {
				return jobOrderService.getJobOrderStatusText(val)
			},
		},
		methods: {
			/**
			 * 全屏事件
			 */
			handleFullScreen() {
				const element = document.getElementById('fullScreen')
				// 判断是否已经是全屏
				// 如果是全屏，退出
				if (this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen()
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen()
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen()
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen()
					}
					console.log('已还原！')
				} else {
					// 否则，进入全屏
					if (element.requestFullscreen) {
						element.requestFullscreen()
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen()
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen()
					} else if (element.msRequestFullscreen) {
						// IE11
						element.msRequestFullscreen()
					}
					console.log('已全屏！')
				}
				// 改变当前全屏状态
				this.fullscreen = !this.fullscreen
			},
			loadingCallback(text) {
				this.loadingText = text
				//console.log('text', text)
			},
		},
		created() {
			this.params = this.$route.query
			this.loading = true

			//获取工单的统计信息。
			jobOrderService
				.getJobOrderStatusByIdAsync(this.job_order_id)
				.then(res => {
					this.data = res
					this.loading = false
				})
				.catch(err => {
					console.log(err)
				})
				.finally(() => {
					this.loading = false
				})

			//获取缺陷分布。
			jobOrderService.getJobOrderDefectTypeStatAsync(this.job_order_id, this.loadingCallback).then(res => {
				console.log('缺陷统计结果', res)
				var rows = []
				var chart_rows = []
				for (var attr in res) {
					rows.push({
						type: attr,
						value: parseInt(res[attr]),
					})

					if (this.columns.findIndex(t => t == attr) == -1) this.columns.push(attr)
				}

				this.chartData = {
					title: '',
					columns: ['type', 'value'],
					rows: rows,
				}
			})
		},
	}
</script>

<style scoped>
	.title {
		font-size: 18px;
		font-weight: bold;
		padding-top: 7px;
	}

	.stat-table {
		padding: 0 1rem;
	}
	.stat-table ul {
		margin: 0;
		padding: 0;
	}

	.stat-table ul li {
		list-style: none;
		padding: 3px 5px;
		line-height: 50px;
		margin-bottom: 20px;
		font-size: 22px;
	}

	.stat-table ul li span {
		color: #aaa;
	}

	.progress {
		margin: 20px 0;
		border-top: 1px #eee solid;
		padding: 20px 0;
	}

	.progress label {
		font-size: 12px;
		margin-bottom: 10px;
		display: block;
		color: #aaa;
	}

	.view {
		background-color: #fff;
	}
</style>
